import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IIndexAttributeData } from "../model/IndexAttributeData";
import IndexAttributeDataMapper from "../service/IndexAttributeDataMapper";
import IndexAttributeDataParamMapper from "../service/IndexAttributeDataParamMapper";

export default class GetIndexAttributeDataByTypeInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexAttributeData>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(indexTypeId: number) {
    return this.resource.execute(
      `${Constants.indexTypeAttributePath}/data/type/${indexTypeId}`,
      IndexAttributeDataMapper,
      IndexAttributeDataParamMapper
    );
  }
}
